// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  leaveApprovers: [],
  totalLeaveApprovers: 0,
}

export const mutations = {
  SET_LEAVE_APPROVERS(state, leaveApprovers) {
    state.leaveApprovers = leaveApprovers
  },
  SET_TOTAL_LEAVE_APPROVERS(state, totalLeaveApprovers) {
    state.totalLeaveApprovers = totalLeaveApprovers
  },
  ADD_LEAVE_TYPE(state, leaveType) {
    state.leaveTypes.push(leaveType)
  },
  EDIT_LEAVE_APPROVER(state, leaveApprover) {
    const index = state.leaveApprovers.findIndex(
      (el) => el.employee_uuid === leaveApprover.employee_uuid
    )
    if (index !== -1) {
      state.leaveApprovers.splice(index, 1, leaveApprover)
    }
  },
  DELETE_LEAVE_TYPE(state, leaveTypeUuid) {
    const index = state.leaveTypes.findIndex(
      (el) => el.leave_type_uuid === leaveTypeUuid
    )
    if (index !== -1) state.leaveTypes.splice(index, 1)
  },
}

export const actions = {
  fetchLeaveApprovers({ commit }, payload) {
    return ApiService.fetchLeaveApprovers(payload)
      .then((res) => {
        const leaveApprovers = res.data.data
        commit('SET_LEAVE_APPROVERS', leaveApprovers)
        commit('SET_TOTAL_LEAVE_APPROVERS', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchLeaveApprover({ commit }, payload) {
    return ApiService.fetchLeaveApprover(payload)
      .then((res) => {
        const leaveApprover = res.data
        return leaveApprover
      })
      .catch((error) => {
        throw error
      })
  },
  addLeaveType({ commit }, payload) {
    return ApiService.addLeaveType(payload)
      .then((res) => {
        const leaveType = res.data
        commit('ADD_LEAVE_TYPE', leaveType)
      })
      .catch((error) => {
        throw error
      })
  },
  editLeaveApproverEmployees({ commit }, payload) {
    return ApiService.editLeaveApproverEmployees(payload)
      .then((res) => {
        const leaveApprover = res.data
        commit('EDIT_LEAVE_APPROVER', leaveApprover)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteLeaveType({ commit }, payload) {
    return ApiService.deleteLeaveType(payload)
      .then(() => {
        commit('DELETE_LEAVE_TYPE', payload.leave_type_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
}
